import * as React from "react";
import Typography from "antd/lib/typography";
import Button from "antd/lib/button";
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import { useState } from 'react';
import { useDispatch } from "react-redux";
import { Skeleton } from 'one-model-local';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    patientStubForUpcomingAppts
} from 'one-stubs';
const { Text } = Typography;
import {
  Version
} from 'one-simulator';
import { useCtx } from 'one-ui-provider';
import { reinitAction as setPatientMatchReinitAction} from 'one-state-patient-match';



let apptstubdata = patientStubForUpcomingAppts();

function callerdata(dispatch: any, ani: any, dnis: any, consolidated_api_invocation: any) {
    // if (ani) {
    //     let skeleton: Skeleton = {
    //         source_skeleton: true,
    //         subject_skeleton: true,
    //         callingDestination_skeleton: true
    //     }
    //     dispatch({
    //         type: "caller-patient",
    //         payload: {
    //             number: ani,
    //             dnis: dnis
    //         }
    //     });
    //     dispatch({
    //         type: "getcallerdetails",
    //         payload: {
    //             number: ani,
    //             type: "Patient"
    //         }
    //     });
    //     dispatch(setSkeletonAction(
    //         skeleton
    //     ));
    // }
    // else if (patientType === "provider") {
    //     let skeletonprovider: Skeleton = {
    //         source_skeleton: true,
    //         subject_skeleton: false,
    //         callingDestination_skeleton: true
    //     }
    //     dispatch({
    //         type: "caller-provider",
    //         payload: {
    //             number: ani,
    //             dnis: dnis
    //         }
    //     });
    //     dispatch({
    //         type: "getcallerdetails",
    //         payload: {
    //             number: ani,
    //             type: "Provider"
    //         }
    //     });
    //     dispatch(setSkeletonAction(
    //         skeletonprovider
    //     ));
    // }
    if (ani) {
        //Reset the gadget before New Call.
        dispatch({
          type: "one-state-subject/reset",
          payload: {
            number: "",
            dnis: ""
          }
        });

        let skeleton: Skeleton = {
            source_skeleton: true,
            subject_skeleton: true,
            callingDestination_skeleton: true
        }

        dispatch({
            type: "one-state-choosecaller/set",
            payload: {
                number: ani,
                dnis: dnis,
                visible:true,
                start:true,
                demo: true
            }
        });

        if (consolidated_api_invocation) {
          dispatch({
            type: "consolidated-api-one",
            payload: {
              number: ani,
              type: "Patient",
              dnis: dnis
            }
          });
        } else {
          dispatch({
            type: "caller-patient",
            payload: {
              number: ani,
              dnis: dnis
            }
          });
          dispatch({
            type: "getcallerdetails",
            payload: {
              number: ani,
              type: "Patient"
            }
          });
        }
        dispatch(setSkeletonAction(
            skeleton
        ));
    }
}

export const CallSelection = () => {
    const { settings } = useCtx();
    const { compatible } = settings;
    const { consolidated_api_invocation } = compatible;
    const dispatch = useDispatch();
    const [ani, setAni] = useState('');
    const [dnis, setDnis] = useState('');
    //const [patientType, setPatientType] = useState("Select Type");

    const callerSelection = () => {
        callerdata(dispatch, ani, dnis, consolidated_api_invocation);
    }
    const callerReset = () => {
        dispatch({
            type: "one-state-subject/reset",
            payload: {
                number: ani,
                dnis: dnis
            }
        });

        dispatch({
            type: "one-state-choosecaller/reset",
            payload: {
                number: ani,
                dnis: dnis,
                visible:false,
                start:true
            }
        });
        sessionStorage.removeItem("PatientName");
        dispatch(setPatientMatchReinitAction());
    }

    const renderSimulator = () => (
      <div>
        <Row type="flex" align="middle" gutter={[8, 8]} style={{width: '900px', marginLeft: '50px'}}>
        <Col sm={24} md={4}>
          <Text style={{ color: '#fff' }}> Quick Search:</Text>
        </Col>
        <Col sm={12} md={7}>
          <Row type="flex" align="middle" gutter={[4, 4]}>
            <Col span={12}>
              <Text style={{ color: '#fff' }}> Patient-CallerID: </Text>
            </Col>
            <Col span={12}>
              <input value={ani} onInput={(e) => setAni(e.target.value)} />
            </Col>
          </Row>
        </Col>
        <Col sm={12} md={7}>
          <Row type="flex" align="middle"  gutter={[4, 4]}>
            <Col span={12}>
              <Text style={{ color: '#fff' }}>Patient-CalledTo: </Text>
            </Col>
            <Col span={12}>
              <input value={dnis} onInput={(e) => setDnis(e.target.value)} />
            </Col>
          </Row>
        </Col>
        <Col sm={24} md={6}>
          <Row type="flex" gutter={[4, 4]}>
            <Col span={12}>
              <Button size="small" className="ant-btn--spacer" name="submit" onClick={callerSelection}>
                Submit
              </Button>
            </Col>
            <Col span={12}>
              <Button size="small" className="ant-btn--spacer" name="submit" onClick={callerReset}>
                Reset
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row type="flex" align="middle" gutter={[8, 8]}>
        <Col sm={24} md={4}>
          <Version versionWidth={'1260px'}/>
        </Col>
      </Row>
      </div>
      
      
    );

    return <div className="simulator-container">{renderSimulator()}</div>;
};
